import React, { useEffect, useRef } from "react";

function ProjectTableCell(props) {
  const { width, cellContent, textAlign, className = '', highlight = false } = props;

  const ref = useRef()
  useEffect(() => {
    if (highlight) {
      ref?.current?.scrollIntoView({ block: "center", behavior: "smooth" })
    }
  }, [highlight]);

  return (
    <div
      ref={ref}
      className={`h-full border border-[#B3B3B3] px-0 py-[5px] shrink-0 ${className} ${highlight && 'bg-yellow-100'}`}
      style={{
        width: width,
        textAlign: textAlign || "start",
      }}
    >
      <div className="text-sm leading-[18px] tracking-[1.75px] break-all line-clamp-1">
        {cellContent}
      </div>
    </div>
  );
}

export default ProjectTableCell;
